import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe that merges two objects, similar to using the spread operator.
 * This pipe is useful when you need to combine objects in Angular templates
 * where the spread syntax (...) is not available.
 *
 * Usage: {{ baseObject | mergeObjects:extensionObject }}
 */
@Pipe({
  name: 'mergeObjects',
  // Using pure pipe for better performance - only recalculates when inputs change
  pure: true,
})
export class MergeObjectsPipe implements PipeTransform {
  /**
   * Creates a new object by merging properties from two input objects.
   * Properties from the extension object override properties with the same name in the base object.
   *
   * @param base The base object with initial properties (left side of spread)
   * @param extension The object with properties to override/extend the base (right side of spread)
   * @returns A new object containing all properties from both objects
   */
  transform<T, U>(base: T, extension: U): T & U {
    // Return extension if base is null/undefined
    if (!base) {
      return extension as unknown as T & U;
    }
    // Return base if extension is null/undefined
    if (!extension) {
      return base as unknown as T & U;
    }
    // Create a new object with properties from both objects
    // Equivalent to { ...base, ...extension }
    return Object.assign({}, base, extension);
  }
}
